import { useContext } from "react";
import {HTTPGenericResponse} from "../../constants/FinanceModels";
import {useApi} from "../Api";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import qs from "qs";

export const useClusterSubscriptionConfigurationRepository = () => {
    const { GET, POST, PUT, DELETE } = useApi();

    const PATH = "/finance/cluster-subscription-configuration"

    const {  globalData: { user } } = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);
    
    async function getClusterConfiguration(idCluster: any) {
        const params = {
            legalEntities: [allLegalEntities]
        }
        return GET(`${PATH}/${idCluster}`, {
            params, 
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        }, 
        true);
    }

    function createClusterConfiguration(idCluster: any, configuration: any): Promise<HTTPGenericResponse> {
        return POST(`${PATH}/${idCluster}`, configuration, {}, true);
    }

    function updateClusterConfiguration(idCluster: any, configuration: any): Promise<HTTPGenericResponse> {
        return PUT(`${PATH}/${idCluster}`, configuration, {}, true);
    }

    function getDefaultConfiguration(){
        return {
            "content": [
                {
                    "printoutType": "BE_FREE_EVO",
                    "algorithm": "",
                    "commissionType": "",
                    "coefficient": 0,
                    "legalEntity": "",
                    "dealer": ""
                },
                {
                    "printoutType": "CAR_CLOUD",
                    "algorithm": "",
                    "commissionType": "",
                    "coefficient": 0,
                    "legalEntity": "",
                    "dealer": ""
                },
                {
                    "printoutType": "FLEX_RENT",
                    "algorithm": "",
                    "commissionType": "",
                    "coefficient": 0,
                    "legalEntity": "",
                    "dealer": ""
                },
                {
                    "printoutType": "CAR_BOX",
                    "algorithm": "",
                    "commissionType": "",
                    "coefficient": 0,
                    "legalEntity": "",
                    "dealer": ""
                }
            ]
        }
    }

    return { getClusterConfiguration, createClusterConfiguration,  updateClusterConfiguration, getDefaultConfiguration };
}